export default __webpack_public_path__ + "static/media/1241.1bc5815a.png";